module.exports = __webpack_public_path__ + "static/media/et-et.0af5e3f0.mp4";